import request from '@/utils/request'

// 获取采购订单下达主表信息
export function coopPoCreateHead(poCreateHeadId) {
  return request({
    url: `/api/coop/coopPoCreateHead/${poCreateHeadId}`,
    method: 'get'
  })
}

// 获取采购订单下达主表信息及附件
export function slectHeadInfo(poCreateHeadId) {
  return request({
    url: `/api/coop/coopPoCreateHead/slectHeadInfo/${poCreateHeadId}`,
    method: 'get'
  })
}

// 获取采购订单下达明细
export function selectDetail(poCreateHeadId) {
  return request({
    url: `/api/coop/coopPoCreateItem/selectDetail/${poCreateHeadId}`,
    method: 'get'
  })
}

// 获取采购订单下达付款计划
export function selectPlan(poCreateHeadId) {
  return request({
    url: `/api/coop/coopPoCreatePayPlan/selectPlan/${poCreateHeadId}`,
    method: 'get'
  })
}
